import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { loadAndDisplay as loadAndDisplayInModal } from '@controllers/main/modal-window_controller';
import RailsEnv from '@frontend/app/features/RailsEnv';

export default class extends Controller {
  loadModal() {
    if (
      RailsEnv.isTest() ||
      CurrentUser.userObject().hasDismissedThreadReplyModal
    ) {
      return true;
    }

    loadAndDisplayInModal(window.ENV.threadReplyModalUrl);
    document
      .querySelector('.modal-window__window')
      .classList.add('profiles-thread-reply-modal__window');
  }
}
